import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import { GameHowl } from "../../../vendor_core/core/src/utils/GameHowl";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { Tween } from "../../../vendor_core/core/src/Tween";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIModes, UIStates } from "../../../vendor_core/core/src/ui/UIStates";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import GameSoundVars from "../enums/GameSoundVars";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import VendorModel from "../../../vendor_core/src/model/VendorModel";
import BackgroundHelper from "../view/background/TRWBackgroundHelper";
import { Ease } from "../../../vendor_core/core/src/Ease";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import { Timeline } from "../../../vendor_core/core/src/Timeline";
import App from "../../../vendor_core/core/src/App";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import Locale from "../../../vendor_core/core/src/utils/Locale";
import { State } from "../../../vendor_core/core/src/states/State";
import InstanceFactory from "../../../vendor_core/core/src/factories/InstanceFactory";
import TextField from "../../../vendor_core/core/src/views/components/TextField";
import KeyboardManager from "../../../vendor_core/core/src/utils/KeyboardManager";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import { VendorCommandsEnum } from "../../../vendor_core/src/commands/VendorCommandsEnum";
import { Point } from "pixi.js";
import { FadeIn, FadeOut } from "../../../vendor_core/core/src/transitions/TransitionAnimations";
import SoundVars from '../../../vendor_core/core/src/const/SoundVars';
import Layout from "../../../vendor_core/core/src/utils/Layout";

export default class TRWEnterFreespinsState extends State {
    private outroAnimDuration: number = 5;
    protected winMusic: GameHowl | undefined;
    private isSceneClosed = false;

    public enter() {

        KeyboardManager.disable();
        // CommandManager.execute(VendorCommandsEnum.FEATURE_STARTED);
        super.enter();
        this.isSceneClosed = false;

        if (!UIController.isComponentHidden("settings")) {
            InstanceFactory.getClass("Settings").hide()
        }

        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as ReelGroup;
        reelGroup.winSymbolsView.unlockAll();
        reelGroup.winSymbolsView.stopAll();
        reelGroup.hideLinesAndInfo(true);

        this.showPopup();
    }

    public showPopup() {
        // App.dispatcher.emit(`${GameEvents.SHOW_FREE_SPIN_INTRO}_${SpinModel.featureMode}`);
        // App.dispatcher.emit(GameEvents.SHOW_FREE_SPIN_INTRO);
        // SoundController.playSound(`${GameSoundVars.FREE_SPINS_INTRO}_${SpinModel.featureMode - 1}`);

        ViewManager.getLayer("SplashOverlay").setScene("open");

        const scene = ViewManager.getLayer(DefaultLayers.Popups).setScene("freespinssummary");
        CommandManager.execute(Commands.UPDATE_FREE_SPINS);
        scene.interactive = true;

        const transitionDuration = 0.5;

        const introEffect = scene.spineAnimations.get("fsIntroOutro");

        const headerTxt = scene.sceneTextFields.get("header");
        headerTxt.alpha = 0;
        const title2 = scene.sceneTextFields.get("title2") as TextField;
        title2.alpha = 0;
        const clickToStart = scene.sceneTextFields.get("click_to_start") as TextField;
        clickToStart.alpha = 0;
        const fsWin = scene.sceneTextFields.get("fsWin") as TextField;
        fsWin.alpha = 0;
        headerTxt.text = Locale.getString("fs_summary_header");

        let winMoney = scene.sceneMoneyFields.get("win_counter");
        winMoney.alpha = 0;

        let winSpins = scene.sceneTextFields.get("win_spins");
        winSpins.alpha = 0;
        winSpins.text = `${SpinModel.freespinsWon}`;

        const obj = headerTxt.children[0];
        obj.scale.set(0, 0);

        const winSpinsObj = winSpins.children[0];

        Tween.delayedCall(transitionDuration, () => {
            // introEffect.playAsync("loop_intro").then(() => introEffect.playAsync("loop_intro"));
            SoundController.playSound(`introTransition`, false);
            Layout.isLandscape() ? introEffect.playChainingAnim("intro") : introEffect.playChainingAnim("intro_pt");
            FadeIn(headerTxt, 1);
            FadeIn(title2, 1);
            FadeIn(clickToStart, 1);
            FadeIn(fsWin, 1);
            FadeIn(winSpins, 1);
            Tween.fromTo(obj.scale, 1,
                {
                    x: 0.9,
                    y: 0.9,
                },
                {
                    x: 1,
                    y: 1,
                    yoyo: true,
                    repeat: -1,
                }
            );
            Tween.fromTo(winSpinsObj.scale, 1.5,
                {
                    x: 0.9,
                    y: 0.9,
                },
                {
                    x: 1,
                    y: 1,
                    yoyo: true,
                    repeat: -1,
                }
            );
        });

        Tween.delayedCall(2, () => {
            scene.once(PointerEvents.DOWN, () => {
                // App.dispatcher.emit(`${GameEvents.FREE_SPIN_INTRO_CLOSED}_${SpinModel.featureMode}`);
                App.dispatcher.emit(GameEvents.FREE_SPIN_INTRO_CLOSED);
                Tween.delayedCall(transitionDuration, () => {
                    SoundController.playSound(`transitionEnd`, false);
                    FadeOut(headerTxt, 0.3);
                    FadeOut(title2, 0.3);
                    FadeOut(clickToStart, 0.3);
                    FadeOut(fsWin, 0.3);
                    FadeOut(winSpins, 0.3);
                    introEffect.playAsync("intro_end")
                        .then(() => {
                            this.closePopup(scene);
                        });
                });
            })
        });


    }

    public closePopup(scene: SceneView) {
        if (!this.isSceneClosed) {

            this.isSceneClosed = true;

            let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                .getCurrentScene()
                .getSubView("ReelGroup") as ReelGroup;
            reelGroup.winSymbolsView.unlockAll();
            reelGroup.winSymbolsView.stopAll();
            reelGroup.hideLinesAndInfo(true);
            ViewManager.getLayer(DefaultLayers.Popups).clear();
            ViewManager.getLayer("FreespinCounter").clear();
           ////// BackgroundHelper.backgrounFsClose().then(BackgroundHelper.backgroundLoop);

            // UIController.setState(UIStates.IDLE);
            UIController.setMode(UIModes.DEFAULT);

            ViewManager.getLayer("SplashOverlay").clear();
            // SpinModel.exitFreespins();

            if (this.winMusic) {
                SoundController.stopSound(this.winMusic);
            }

            reelGroup.revealAllSymbols();
            this.startFreeSpins();
            scene.destroy();
            this.exit();
        }
    }

    private startFreeSpins(): void {
        if (!SpinModel.isInFreespins()) {
            this.playFrameAnim();
            this.playBGAnim();
        }
        // UIController.setState(UIStates.FREE_SPINS);
        UIController.setMode(UIModes.FREE_SPINS);
        SpinModel.enterFreespins();
        // this.cleanPersistentMulti();

        if (SpinModel.tempWinAmount > 0 && SpinModel.accumulatedWin === 0) {
            SpinModel.accumulatedWin = SpinModel.tempWinAmount;
        }

        SpinModel.freespinSelectScreen = null;
    }

    // cleanPersistentMulti(): void {
    //     const fsCounterScene = ViewManager.getLayer(DefaultLayers.FreespinCounter).setScene("open");
    //     const persistentMultiplierField = fsCounterScene.sceneTextFields.get("pm_counter");
    //     persistentMultiplierField.text = "x1";
    // }

    playFrameAnim(): void {
        const frScene = ViewManager.getLayer(DefaultLayers.ReelsFront).getCurrentScene();
        const anim = frScene?.spineAnimations?.get("frame_anticipation");
        if (anim) {
            anim.play("loop_fs");
        }
    }
    playBGAnim(): void {
        const frScene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
        const anim = frScene?.spineAnimations?.get("animation");
        if (anim) {
            anim.playAsync("mg_to_fs").then(() => {
                anim.play("fs_loop");
            });
        }
    }
}
